import {fetchData} from "./index";


const api = {
  fetchParking: () => {
    return fetchData('/api/parking/info') as Promise<ParkingResponse>
  }
}

export default api;